import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUserData, getUserPicture, logout } from "../../store/ui-actions";

import Icon from "@material-ui/core/Icon";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Avatar from "@material-ui/core/Avatar";
import Styles from "./MainNavigation.module.css";
import Button from "@material-ui/core/Button";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import PersonIcon from "@material-ui/icons/Person";
import Divider from "@material-ui/core/Divider";

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// import Button from '@material-ui/core/Button';
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
}));

export default function PrimarySearchAppBar(props) {
	const dispatch = useDispatch();
	const history = useHistory();
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [anchorEl2, setAnchorEl2] = React.useState(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

	const [selectedIndex, setSelectedIndex] = React.useState(1);

	const isMenuOpen = Boolean(anchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	const url = window.location.href;
	const domain = url.split(/[/?#]/)[0];

	const handleProfileMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		handleMobileMenuClose();
	};

	const handleLogoClick = () => {
		window.location.href = `${domain}/admin/dashboard`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/myProfile";
	};

	const handleNotificationsClick = () => {
		window.location.href = `${domain}/admin/notifications`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/myProfile";
	};

	const handleMeuPerfilClick = () => {
		window.location.href = `${domain}/admin/user-profile`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/myProfile";
	};

	const handleSairClick = () => {
		// window.location.href = `${domain}/auth/login`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/myProfile";
		dispatch(logout(apiConfigData.endpoint.logout, autenticationData.cookieToken));
	};

	const handleMobileMenuOpen = (event) => {
		setMobileMoreAnchorEl(event.currentTarget);
	};

	const handleCandidaturasClick = (event) => {
		window.location.href = `${domain}/admin/userApplication`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/userApplication";
	};

	const handleCandidaturaClick = (event) => {
		window.location.href = `${domain}/admin/applications`;
		// "https://sigpape-dev.northeurope.cloudapp.azure.com/admin/userApplication";
	};

	const handleClick = (event) => {
		setAnchorEl2(event.currentTarget);
	};

	const handleClose = (event, index) => {
		console.log("index", index);
		setSelectedIndex(index);

		// const menuItem = event.currentTarget.id;
		// console.log(menuItem);

		switch (index) {
			case 0:
				history.push("/formacao");
				break;
			case 1:
				history.push("/formacao/courses");
				break;
			case 2:
				history.push("/formacao/calendar");
				break;
			case 3:
				history.push("/formacao/catalog");
				break;
		}

		setAnchorEl2(null);
	};

	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const userData = useSelector((state) => state.uiData.user);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const user_url =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.dashboard.user;

	const user_avatar =
		apiConfigData.endpoint.avatar + props.userId;
	
	useEffect(() => {
		console.log("useEffect MainNavigation");
		if (autenticationData.token !== "") {
			// console.log("useEffect MainNavigation TOKEN IN STORE", autenticationData);
			dispatch(getUserData(user_url, autenticationData.token));
			dispatch(getUserPicture(user_avatar, autenticationData.cookieToken));
		}
	}, []);

	useEffect(() => {
		console.log("userData", userData);
	}, [userData]);

	const menuId = "primary-search-account-menu";
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMenuOpen}
			onClose={handleMenuClose}
			className={Styles["menu-open"]}
		>
			<MenuItem className={Styles["menu-item-welcome"]}>
				Bem vindo!
			</MenuItem>
			<MenuItem
				className={Styles["menu-item-perfil"]}
				onClick={handleMeuPerfilClick}
			>
				<PersonIcon className={Styles["icon"]} />
				Meu perfil
			</MenuItem>
			<Divider />
			<MenuItem
				className={Styles["menu-item-sair"]}
				onClick={handleSairClick}
			>
				<DirectionsRunIcon className={Styles["icon"]} />
				Sair
			</MenuItem>
		</Menu>
	);

	return (
		<div className={classes.grow}>
			<AppBar position="static">
				<Toolbar className={Styles["Navigation-menu"]}>
					<div className={Styles["menu-top-row"]}>
						<div>
							<img
								className={Styles["logo"]}
								// src="data:image/png;base64,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"
								src="https://sigpape-dev.northeurope.cloudapp.azure.com:450/static/media/INEFOP_azul.6d02d45b.png"
								onClick={handleLogoClick}
							></img>
						</div>
						<div className={Styles["menu-top-row-right"]}>
							<div className={Styles["icon-button-notification"]} onClick={handleNotificationsClick}>
								<NotificationsIcon style={{ fontSize: 26 }}/>
							</div>
							<Button
								className={Styles["btn-perfil"]}
								onClick={handleProfileMenuOpen}
							>
								{userData.picture && (
									<Avatar
										className={Styles["avatar"]}
										alt="avatar"
										src={
											userData.picture.photo
												? `data:image/jpg;base64, ${userData.picture.photo}`
												: ""
										}
									>{`${userData.picture.name.charAt(
										0
									)} ${userData.picture.userSingular.lastName.charAt(
										0
									)}`}</Avatar>
								)}
								{/* {userData.name && ( */}
								{userData.picture && (
								<Typography className={Styles["avatar-name"]}>
									{/* {userData.name} */}
									{`${userData.picture?.name} ${userData.picture?.userSingular?.lastName}`}
								</Typography>
								)}
								<ExpandMoreIcon/>
							</Button>
						</div>
					</div>
					<div className={Styles["menu-bottom-row"]}>
						{/* <Button
							className={Styles["my-menu-item"]}
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={handleCandidaturasClick}
						>
							Candidaturas
						</Button> */}
						<Button
							className={Styles["my-menu-item"]}
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={handleClick}
						>
							Formação Profissional
							<ExpandMoreIcon/>
						</Button>
						<Menu
							id="simple-menu"
							anchorEl={anchorEl2}
							keepMounted
							open={Boolean(anchorEl2)}
							onClose={handleClose}
						>
							<MenuItem
								selected={0 === selectedIndex}
								onClick={(event) => handleClose(event, 0)}
							>
								Dashboard
							</MenuItem>
							<MenuItem
								selected={1 === selectedIndex}
								onClick={(event) => handleClose(event, 1)}
							>
								Meus Cursos
							</MenuItem>
							<MenuItem
								selected={2 === selectedIndex}
								onClick={(event) => handleClose(event, 2)}
							>
								Calendário
							</MenuItem>
							<MenuItem
								selected={3 === selectedIndex}
								onClick={(event) => handleClose(event, 3)}
							>
								Catálogo
							</MenuItem>
						</Menu>
					</div>
					{/* <Typography className={classes.title} variant="h6" noWrap>
            Material-UI
          </Typography> */}
					{/* <img
						className={Styles["logo"]}
						src="data:image/png;base64,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"
						onClick={handleLogoClick}
					></img> */}
					{/* <div className={Styles["menu-left"]}>
						<div style={{ paddingLeft: "38px" }}>
							<Button
								className={Styles["my-menu-item"]}
								aria-controls="simple-menu"
								aria-haspopup="true"
								onClick={handleCandidaturasClick}
							>
								Candidaturas
							</Button>
							<Button
								className={Styles["my-menu-item"]}
								aria-controls="simple-menu"
								aria-haspopup="true"
								onClick={handleClick}
							>
								Formação Profissional
							</Button>
							<Menu
								id="simple-menu"
								anchorEl={anchorEl2}
								keepMounted
								open={Boolean(anchorEl2)}
								onClose={handleClose}
							>
								<MenuItem
									selected={0 === selectedIndex}
									onClick={(event) => handleClose(event, 0)}
								>
									Dashboard
								</MenuItem>
								<MenuItem
									selected={1 === selectedIndex}
									onClick={(event) => handleClose(event, 1)}
								>
									Meus Cursos
								</MenuItem>
								<MenuItem
									selected={2 === selectedIndex}
									onClick={(event) => handleClose(event, 2)}
								>
									Calendário
								</MenuItem>
								<MenuItem
									selected={3 === selectedIndex}
									onClick={(event) => handleClose(event, 3)}
								>
									Catálogo
								</MenuItem>
							</Menu>
						</div>
					</div> */}
					{/* <div className={classes.grow} /> */}
					{/* <div className={Styles["menu-right"]}>
						<Button
							variant="contained"
							color="primary"
							disableElevation
							className={Styles["btn-candidatura"]}
							onClick={handleCandidaturaClick}
						>
							Candidatura
						</Button>
						<IconButton
							color="inherit"
							onClick={handleNotificationsClick}
						>
							<NotificationsIcon />
						</IconButton>
						<Button
							className={Styles["btn-perfil"]}
							onClick={handleProfileMenuOpen}
						>
							{userData.picture && (
								<Avatar
									className={Styles["avatar"]}
									alt="avatar"
									src={
										userData.picture.photo
											? `data:image/jpg;base64, ${userData.picture.photo}`
											: ""
									}
								>{`${userData.picture.name.charAt(
									0
								)} ${userData.picture.userSingular.lastName.charAt(
									0
								)}`}</Avatar>
							)}						
							{userData.picture && (
							<Typography className={Styles["avatar-name"]}>
								{`${userData.picture?.name} ${userData.picture?.userSingular?.lastName}`}
							</Typography>
							)}
						</Button>
					</div> */}
				</Toolbar>
			</AppBar>
			{renderMenu}
		</div>
	);
}
